import { useState, useEffect, useRef } from 'react';

const useInfiniteScroll = (callback) => {
    const [isFetching, _setIsFetching] = useState(false);
    const [isDone, _setIsDone] = useState(false);

    // we need ref versions of isFetching and isDone so they take effect immediately in the handleScroll
    const _isFetching = useRef(false);
    const _isDone = useRef(false);

    const setIsFetching = (amIFetching) => {
        _isFetching.current = amIFetching;
        _setIsFetching(amIFetching);
    }
    const setIsDone = (amIDone) => {
        _isDone.current = amIDone;
        _setIsDone(amIDone);
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        if (!isFetching)
            return;
        callback(false);
    }, [isFetching]);

    function handleScroll() {
        const pixelsFromBottomToInitialteScroll = 200;
        if ((window.innerHeight + document.documentElement.scrollTop) < (document.documentElement.offsetHeight - pixelsFromBottomToInitialteScroll) ||
            _isFetching.current || _isDone.current)
            return;
        setIsFetching(true);
    }

    return [isFetching, setIsFetching, isDone, setIsDone];
};

export default useInfiniteScroll;